import React from "react";
import { Route, Routes } from "react-router-dom";
import ApplicationForm from '../components/core/Applications/Form';
import ApplicationList from '../components/core/Applications/List';
import ApplicationFunctionalityForm from '../components/core/ApplicationsFunctionalities/Form.js';
import ApplicationFunctionalityList from '../components/core/ApplicationsFunctionalities/List.js';
import ApplicationInstancesForm from '../components/core/ApplicationsInstances/Form';
import ApplicationInstancesList from '../components/core/ApplicationsInstances/List';
import ApplicationProfileForm from '../components/core/ApplicationsProfiles/Form';
import ApplicationProfileList from '../components/core/ApplicationsProfiles/List';
import EmailConfigsForm from "../components/core/EmailConfigs/Form";
import CRUDBackEndForm from '../components/core/ExampleCRUDBackEnd/Form';
import CRUDBackEndList from '../components/core/ExampleCRUDBackEnd/List';
import CRUDDialog from '../components/core/ExampleCRUDDialog/Crud';
import CRUDFrontEndForm from '../components/core/ExampleCRUDFrontEnd/Form';
import CRUDFrontEndList from '../components/core/ExampleCRUDFrontEnd/List';
import ExampleDataGrid from "../components/core/ExampleDataGrid/ExampleDataGrid.js";
import ExampleForm from "../components/core/ExampleForm/Form"
import LoginConfigsForm from "../components/core/LoginConfigs/Form"
import LoginConfigsList from "../components/core/LoginConfigs/List"
import AttemptsForm from "../components/core/Attemppts/Form"
import ExampleWhatsappApiForm from "../components/core/ExampleWhatsappAPI/Form.js";
import Home from '../components/core/Home.js';
import ForgotPassword from '../components/core/Login/ForgotPassword.js';
import Login from '../components/core/Login/Login.js';
import ResetPassword from '../components/core/Login/ResetPassword.js';
import Logout from '../components/core/Logout.js';
import LogsList from "../components/core/Logs/List";
import RestrictedArea from '../components/core/RestrictedArea.js';
import UserForm from '../components/core/Users/Form';
import UserList from '../components/core/Users/List';
import UserEdit from '../components/core/Users/UserEdit';
import DirectChat from '../components/core/Support/DirectChat';
import SupportForm from '../components/core/Support/Form';
import SupportList from '../components/core/Support/List';
import SupportProfileForm from '../components/core/SupportProfiles/Form';
import AfterResetList from '../components/core/Examples/CustomList/AfterReset/List.js'
import RouteMapExample from '../components/core/Examples/Map/RouteMap'
import ClusterMapExample from '../components/core/Examples/Map/ClusterMap'
import DbMigrationList from '../components/core/DbMigrations/List';
import DbMigrationLogsList from '../components/core/DbMigrationsLogs/List';
import { TutorialsClientCards } from "../components/core/TutorialsClientCards";
import TutorialsManagement from '../components/core/TutorialsManagement/Management';
import TutorialsComponentList from "../components/core/TutorialCardList/List";
import TutorialsComponentForm from "../components/core/TutorialCardList/Form";

function CoreRoutes() {
  return (
    <Routes>
      {/* Home, Login, Logout.. */}
      <Route exact path="/" element={<RestrictedArea content={<Home />} />} />
      <Route exact path="/login" element={<Login />} />
      <Route exact path="/forgotpassword" element={<ForgotPassword />} />
      <Route exact path="/resetpassword/:jwt_token" element={<ResetPassword />} />
      <Route exact path="/logout" element={<Logout />} />
      {/* Applications */}
      <Route exact path="/core/applications/list" element={<RestrictedArea content={<ApplicationList />} />} />
      <Route exact path="/core/applications/add" element={<RestrictedArea content={<ApplicationForm />} />} />
      <Route exact path="/core/applications/edit/:id" element={<RestrictedArea content={<ApplicationForm />} />} />
      <Route exact path="/core/applications/view/:id" element={<RestrictedArea content={<ApplicationForm />} />} />
      {/* Applications Profiles */}
      <Route exact path="/core/applicationsprofiles/list" element={<RestrictedArea content={<ApplicationProfileList />} />} />
      <Route exact path="/core/applicationsprofiles/add" element={<RestrictedArea content={<ApplicationProfileForm />} />} />
      <Route exact path="/core/applicationsprofiles/edit/:id" element={<RestrictedArea content={<ApplicationProfileForm />} />} />
      <Route exact path="/core/applicationsprofiles/view/:id" element={<RestrictedArea content={<ApplicationProfileForm />} />} />
      {/* Applications Instances */}
      <Route exact path="/core/applicationsinstances/list" element={<RestrictedArea content={<ApplicationInstancesList />} />} />
      <Route exact path="/core/applicationsinstances/add" element={<RestrictedArea content={<ApplicationInstancesForm />} />} />
      <Route exact path="/core/applicationsinstances/edit/:id" element={<RestrictedArea content={<ApplicationInstancesForm />} />} />
      <Route exact path="/core/applicationsinstances/view/:id" element={<RestrictedArea content={<ApplicationInstancesForm />} />} />
      {/* Applications Functionalities */}
      <Route exact path="/core/applicationsfunctionalities/list" element={<RestrictedArea content={<ApplicationFunctionalityList />} />} />
      <Route exact path="/core/applicationsfunctionalities/add" element={<RestrictedArea content={<ApplicationFunctionalityForm />} />} />
      <Route exact path="/core/applicationsfunctionalities/edit/:id" element={<RestrictedArea content={<ApplicationFunctionalityForm />} />} />
      <Route exact path="/core/applicationsfunctionalities/view/:id" element={<RestrictedArea content={<ApplicationFunctionalityForm />} />} />
      {/* Users */}
      <Route exact path="/core/users/list" element={<RestrictedArea content={<UserList />} />} />
      <Route exact path="/core/users/add" element={<RestrictedArea content={<UserForm />} />} />
      <Route exact path="/core/users/edit/:id" element={<RestrictedArea content={<UserForm />} />} />
      <Route exact path="/core/users/view/:id" element={<RestrictedArea content={<UserForm />} />} />
      <Route exact path="/core/users/useredit" element={<RestrictedArea content={<UserEdit />} />} />
      {/* Example CRUD Frontend */}
      <Route exact path="/core/examples/crud/frontend/list" element={<RestrictedArea content={<CRUDFrontEndList />} />} />
      <Route exact path="/core/examples/crud/frontend/add" element={<RestrictedArea content={<CRUDFrontEndForm />} />} />
      <Route exact path="/core/examples/crud/frontend/edit/:id" element={<RestrictedArea content={<CRUDFrontEndForm />} />} />
      <Route exact path="/core/examples/crud/frontend/view/:id" element={<RestrictedArea content={<CRUDFrontEndForm />} />} />
      {/* Example CRUD Backend */}
      <Route exact path="/core/examples/crud/backend/list" element={<RestrictedArea content={<CRUDBackEndList />} />} />
      <Route exact path="/core/examples/crud/backend/add" element={<RestrictedArea content={<CRUDBackEndForm />} />} />
      <Route exact path="/core/examples/crud/backend/edit/:id" element={<RestrictedArea content={<CRUDBackEndForm />} />} />
      <Route exact path="/core/examples/crud/backend/view/:id" element={<RestrictedArea content={<CRUDBackEndForm />} />} />
      <Route exact path="/core/examples/cruddialog" element={<RestrictedArea content={<CRUDDialog />} />} />
      {/* Example Form */}
      <Route exact path="/core/examples/form" element={<RestrictedArea content={<ExampleForm />} />} />
      {/* Login Configs */}
      <Route exact path="/core/loginconfigs/list" element={<RestrictedArea content={<LoginConfigsList />} />} />
      <Route exact path="/core/loginconfigs/edit/:core_application_instance_id" element={<RestrictedArea content={<LoginConfigsForm />} />} />
      <Route exact path="/core/loginconfigs/edit" element={<RestrictedArea content={<LoginConfigsForm />} />} />
      <Route exact path="/core/emailconfigs/edit" element={<RestrictedArea content={<EmailConfigsForm />} />} />

      <Route exact path="/core/examples/whatsapp/form" element={<RestrictedArea content={<ExampleWhatsappApiForm />} />} />
      <Route exact path="/core/examples/datagrid" element={<RestrictedArea content={<ExampleDataGrid />} />} />
      <Route exact path="/core/attempts/edit" element={<RestrictedArea content={<AttemptsForm />} />} />

      {/* Logs */}
      <Route exact path="/core/logs/list" element={<RestrictedArea content={<LogsList />} />} />

      {/* Support */}
      <Route exact path="/core/support/add" element={<RestrictedArea content={<SupportForm />} />} />
      <Route exact path="/core/support/edit/:id" element={<RestrictedArea content={<SupportForm />} />} />
      <Route exact path="/core/support/view/:id" element={<RestrictedArea content={<DirectChat />} />} />
      <Route exact path="/core/support/list" element={<RestrictedArea content={<SupportList />} />} />

      {/* Support profiles */}
      <Route exact path="/core/supportprofiles/add" element={<RestrictedArea content={<SupportProfileForm />} />} />

      {/* Custom List After Reset */}
      <Route exact path="/core/examples/customlist/afterreset/list" element={<RestrictedArea content={<AfterResetList />} />} />

      {/* RouteMap */}
      <Route exact path="/core/examples/maps/routemap" element={<RestrictedArea content={<RouteMapExample />} />} />

      {/* ClusterMap */}
      <Route exact path="/core/examples/maps/clustermap" element={<RestrictedArea content={<ClusterMapExample />} />} />

      {/* Migrations */}
      <Route exact path="/core/dbmigrations/list" element={<RestrictedArea content={<DbMigrationList />} />} />

      {/* Migrations Logs */}
      <Route exact path="/core/dbmigrationslogs/list" element={<RestrictedArea content={<DbMigrationLogsList />} />} />

      {/* Tutorial Client View */}
      <Route exact path="/core/tutorialsclient/list" element={<RestrictedArea content={<TutorialsClientCards />} />} />
      <Route exact path="/core/tutorialscard/list/:id" element={<RestrictedArea content={<TutorialsComponentList />} />} />
      <Route exact path="/core/tutorialscard/form/:id/:idTutorial" element={<RestrictedArea content={<TutorialsComponentForm />} />} />

      {/* Tutorials Management */}
      <Route exact path="/core/tutorials/management" element={<RestrictedArea content={<TutorialsManagement />} />} />
      

    </Routes>
  );
}

export default CoreRoutes;